import React, { useState } from 'react';

const CheapenergyMap = ({ onRegionSelect, selectedRegion }) => {
    const [hoveredRegion, setHoveredRegion] = useState(null);
    
    // Add Norwegian region names
    const regionNames = {
        'NO1': 'Øst-Norge',
        'NO2': 'Sør-Norge',
        'NO3': 'Midt-Norge',
        'NO4': 'Nord-Norge',
        'NO5': 'Vest-Norge'
    };
    
    const handleRegionClick = (region) => {
        if (onRegionSelect) {
            onRegionSelect(region);
        }
    };
    
    const getRegionColor = (region) => {
        const baseColors = {
            'NO1': '#FF0000',  // Updated from #0F415E to #FF0000
            'NO2': '#FF0000',  // Updated from #0F415E to #FF0000
            'NO3': '#FF0000',  // Updated from #0F415E to #FF0000
            'NO4': '#FF0000',  // Updated from #0F415E to #FF0000
            'NO5': '#FF0000',  // Updated from #0F415E to #FF0000
        };
        
        if (region === selectedRegion) {
            return baseColors[region];
        } else if (region === hoveredRegion) {
            return baseColors[region] + '99'; // Add transparency
        }
        
        return baseColors[region] + '70'; // More transparency for inactive regions
    };
    
    // Create group elements for both path and text to be clickable together
    const RegionWithLabel = ({ region, path, textX, textY }) => (
        <g 
            onClick={() => handleRegionClick(region)}
            onMouseEnter={() => setHoveredRegion(region)}
            onMouseLeave={() => setHoveredRegion(null)}
            className="cursor-pointer transition-all duration-200"
        >
            <path
                d={path}
                fill={getRegionColor(region)}
                stroke={selectedRegion === region ? '#fff' : '#333'}
                strokeWidth={selectedRegion === region ? 2 : 1}
            />
            <rect 
                x={textX - 40} 
                y={textY - 10} 
                width={80} 
                height={16} 
                fill="rgba(255, 255, 255, 0.7)" 
                rx={4} 
            />
            <text 
                x={textX} 
                y={textY} 
                fill="#000000" 
                fontSize="12" 
                fontWeight="bold" 
                textAnchor="middle"
                dominantBaseline="middle"
            >
                {region} - {regionNames[region]}
            </text>
        </g>
    );
    
    return (
        <div className="map-container">
            <svg viewBox="0 0 362 410.9" xmlns="http://www.w3.org/2000/svg">
                {/* Norway map with regions */}
                <g>
                    {/* NO1 - Southeast Norway */}
                    <RegionWithLabel 
                        region="NO1"
                        path="M131.2,316.4c-1.7,6.7,7.1,8.3,7.2,12.9,0,3.2-2.2,4.7-2.8,7.4-.4,1.7,0,6.2-.2,6.5-.5.5-6.5-1-8.9.9-1.7,1.3-1.5,4.6-2.5,6.6-.3.6-3.1,1.6-3.1,3.3v17c-3.3.6-1.7-3.7-3.2-6.6-1.2-2.2-4.7-4.1-5.5-5.8-1.4-3,0-6.6-.6-9.7-.9-5.1-9.3-6.9-12.9-3.7-3.1,1.3.3,10-3,9.3-.8-.2-11-10.6-11.4-11.3-1.8-4,3.4-16.1,2.5-22-.6-4.3-7.8-9.3-7.1-12.2.2-.9,7.8-8.4,8.9-8.8,7.2-2.2,19.7,2.2,27-1.8,2.1-1.1,3-3.7,6-4.3,1.9-.4,9.3-.7,10.9-.3,1.2.3,1.1,2.9,2.3,4.1,2.6,2.7,7.5,4.2,7.8,8.8.4,6.5-5,4.3-8.3,7.7-.1.3-.3.6-.7.9-.9.9-2,1.1-2.4,1.1Z"
                        textX={120}
                        textY={355}
                    />
                    
                    {/* NO2 - Southwest Norway */}
                    <RegionWithLabel 
                        region="NO2"
                        path="M31.3,379.3c-.2-.2.3-3.9-.2-5.5s-2.4-2.1-2.9-4.3c-2.8-13.6,12.4-2.5,13.4-14.9-7-.3-11.6-1.2-16,5.1-4.7-1.8-1.9-13.2,1.2-14.2h54.4c3.8.6,7.2,8.9,11.5,11s6.4.3,8.6,2.7c-1.4,4.8-4.3,9.4-7.7,12.9-6.6,6.6-9.3,7.3-17,10.8s-4.5,5.7-7,6.4-22.1.6-24.3,0c-4.3-1.2-3.1-7.1-6.3-9.1s-7.5-.6-7.8-1Z"
                        textX={70}
                        textY={390}
                    />
                    
                    {/* NO3 - Central Norway */}
                    <RegionWithLabel 
                        region="NO3"
                        path="M94.1,245.4c.9.2,4.4.2,5-.1,2.3-3.6.2-8.8,1.7-12.2,2.3-5.2,17.6-15.5,21.8-20.5l2.3.4c3.5,5.6,16.8,12.6,17.6,18.5,1.8,12.9-3.9,10.6-8.8,18.1-3.7,5.7.6,6.6.3,8.5s-1.6,1.9-1.8,3.3c-.3,2.3.4,4.8-.2,7s-3.1,2.5-2.8,4.2c.6,3.2,8.9,3.8,5.5,14-2.4,7.2-10,2.8-15.2,4.4-2,.6-3.5,3.8-5.5,4.8-6.1,3.1-18.3-.2-25.4,1.4s-8.9,8.3-11.7,8.8c-1.4.3-4.1-1.6-6.1-1.8-2.9-.3-6.4.5-9-.3-3.3-1-6.9-8.8-12.6-9.2-6.1-.4-11.4,10.3-12.5,10.5s-9.3-.8-9.6-1.1c-2.5-2.4,3.1-8.7,3.1-9.8,0-2.3-3.4-3.3-4-5.4s-.6-9.2-.2-9.6,6.9.3,9.3-.5,7.1-6.8,9.9-7.6,17.3.9,18.7-1.4.4-4.2,0-4.9c-1.3-2-8.3,1.4-6-6.3h16c1.8,0,1.3-5.5,2.1-7.2s6.6-6.7,7.7-7.2l1.8,1.6c-1,8.1,7,9.8,6.6.9l1.9-1.5Z"
                        textX={120}
                        textY={280}
                    />
                    
                    {/* NO4 - North Norway */}
                    <RegionWithLabel 
                        region="NO4"
                        path="M325.9,46.5c-1.2-5.2,9.2-8.5,9.2-11.8,0-1.4-6.1-14.9-7.2-15.5-1.3-.8-15.9-.9-18-.5-2.7.5-3.7,3.5-7.3,4-4,.6-17-.9-19.1.5-2.6,1.8.3,19.4-1.1,23.6-.2.5-7.2,6.7-7.7,6.8-1.2.2-8-6.5-8.4-7.9-2.1-6.8,1.9-9,5.9-13.3.2-1.3-4.1-5.7-5.4-5.4-1.9.3-23.3,22.4-28,25.7-4.1,2.9-10.4,4.3-12.9,8.7-3,5.2,2.9,14.8-8.2,11.4-3.6-1.1-8.9-7.8-10.8-7.8-1.4,0-11.2,9.6-11.6,11.1-1.2,4.1,1.2,19.8-1.2,21.5-2.9,2-17.1-1.1-21.7,1-3.5,1.6-14.9,14.7-18.6,18h14.9c.4,0,3.4-3.9,5.6-4.7.9-.3,6.3-1.6,5.2,1.1-2.4,3.8-12.4,10.6-13.9,13.9-1.8,3.9.8,8.4-3.1,13.3-2.9,3.6-13.6,10.6-15.4,14.5-1.8,3.9.7,10.2-1.1,14.4-1.2,2.7-9.5,6.8-9.8,8-1.5,5.5,1.5,15.9-.4,22l-9.8,10.7,19.6,18.6c10.5.9,21.3,3.8,18.5-10.8-4.3-.4-9.1,2.1-9.2-3.7-.2-8.8,10.3-10.5,11.2-15.4.5-2.4.5-14,0-16.4-.6-3.4-5.1-3.8-3.9-8,1.9-6.8,14.7-4.3,15.3-4.9.4-.4-.3-9.5,0-11.3h0c0-.5,1-3,1.5-3.5.4-.5.8-.9,1.4-1.2,1.8-1.5,3.5-2.8,5.8-4.4.6-.4.7-1.4.5-2.2,1.8-4.6-4-6.7-4.2-8.8-.3-2.9,2.4-3.5,3-5.3.9-3-.6-6.5.7-9.6.3-.8,6.7-6.9,7.4-7.1,2.7-.7,4.2,2.6,6,4,6.1-2.3,2-13.2,4.6-15,2.8-1.9,17.5.9,21.8-.9,2.3-1.6,0-10.3,1.1-13.3,1-2.9,5.5-1.2,6-1.7.4-.3-.3-6.7,0-8.2,8.6-2.7,11.6,7.4,17.6,9.8,2.4.9,4.9.3,7.3,1,2.1.6,7.1,4.3,9.1,2.5.7-.6-.3-4.4,3.8-5,4.5-.7,6.1,2.1,9.5,2.9,6.3,1.4,3.5-.8,5.2-4.6,1.1-2.6,3.7-2.8,4.4-4.1,2.7-4.4-.2-29.1,1-30.2.3-.2,4.8.3,6.5-.2,2-.6,2.5-3.3,5.4-3.9,9-1.8,8,2.9,11.8,4.6,7.8,3.4,8.3-3.7,9.3,9.8.4.9.7.9,1,0,.8-5.1,10.5-9.3,13.4-13.9-3.2-3.6-8-2.4-12.3-2.6Z"
                        textX={200}
                        textY={100}
                    />
                    
                    {/* NO5 - West Norway - Adjusted text position */}
                    <RegionWithLabel 
                        region="NO5"
                        path="M83.2,319.6c-.5-1.3-8.1-10.6-9.4-11.2-4.6-2.4-9-.1-13.1-1.4-2.5-.8-8.7-8.3-10.7-8.9-5.7-1.6-9.9,10-13.7,11.7-3.7,1.7-10-1.1-13.4,3.1-1.8,2.2-.7,5.3-1,5.7-.1.1-.5,1.1,0,1,.5.2.3.8,0,1-2.4,6.1,7.3,9.7,8.1,13.1.7,2.6-4,5.3-3,8.5h53.6c-.2-6.2,4.8-17.1,2.5-22.6Z"
                        textX={50}
                        textY={320} // Adjusted Y position to avoid cutoff
                    />
                </g>
            </svg>
        </div>
    );
};

export default CheapenergyMap;
